import styled from 'styled-components';
import { LocalizedLink } from '@rsc/gatsby-localization-helpers';
import sharedStyles from '../styles';

const Wrapper = styled.li`
  min-height: 2rem;
  padding: ${sharedStyles.spacing['spacing-lg']}
    ${sharedStyles.spacing['spacing-md']};
  border-bottom: solid 1px ${({ theme }) => theme.colors.border};
`;

const LineItemDetails = styled(LocalizedLink)`
  display: flex;
  gap: ${sharedStyles.spacing['spacing-sm']};
  position: relative;
  margin-bottom: ${sharedStyles.spacing['spacing-lg']};
  text-decoration: none;
  color: inherit;
  z-index: 1;

  &:hover {
    text-decoration: none;

    h3 {
      text-decoration: underline;
    }

    h4 {
      text-decoration: none;
    }
  }

  img {
    width: 4rem;
    display: block;
    margin-right: ${sharedStyles.spacing['spacing-sm']};
    align-self: flex-start;
  }

  div {
    margin: 0 ${sharedStyles.spacing['spacing-1xl']} 0.25em 0;
  }

  h3 {
    /* margin: 0 ${sharedStyles.spacing['spacing-1xl']} 0.25em 0; */
    padding: 0;
    font-weight: revert;
    font-size: 1rem;
    line-height: 1.15;

    a {
      color: inherit;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  h4 {
    margin: 0;
    margin-bottom: ${sharedStyles.spacing['spacing-1xs']};
    padding: 0;
    font-weight: normal;
    font-size: ${sharedStyles.fontSize.base};
  }

  p {
    margin: 0;
    padding: 0;
    font-size: ${sharedStyles.fontSize.sm};
    font-weight: initial;
  }
`;

const LineItemQuantityChanger = styled.div`
  display: flex;
`;

const QuantityControls = styled.div`
  font-size: 1rem;
  display: flex;
  div {
    background: white;
    min-width: 3rem;
    max-width: 3rem;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: solid 2px ${({ theme }) => theme.colors.inputBorder};
    border-bottom: solid 2px ${({ theme }) => theme.colors.inputBorder};
    z-index: 1;
    height: 2.5rem;
  }
`;

const TotalPrice = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: ${sharedStyles.fontSize.base};
`;

export {
  Wrapper,
  LineItemDetails,
  LineItemQuantityChanger,
  QuantityControls,
  TotalPrice,
};
